@if (vm$ | async; as vm) {
  <div [href]="vm.vaelgInstallationHref" (click)="onLinkClick($event, vm.vaelgInstallationHref)">
    @if (vm.vaelgInstallationHref) {
      <a
        class="link"
        role="link"
        [attr.title]="'Måler: ' + vm.maalerNr"
        [href]="vm.vaelgInstallationHref"
        (click)="onLinkClick($event, vm.vaelgInstallationHref)"
        >
        <div class="wrapper">
          <div>
            <span>
              {{ vm.adresse }}
            </span>
          </div>
          @if (vm.maalerNr) {
            <small>Måler: {{ vm.maalerNr }}</small>
          }
          @if (vm.adresse && !vm.maalerNr) {
            <small>Status: Passiv</small>
          }
        </div>
        @if (vm.vaelgInstallationHref) {
          <small>SKIFT...</small>
        }
      </a>
    } @else {
      <div class="no-link">
        <div class="wrapper">
          <div>
            <span>
              {{ vm.adresse }}
            </span>
          </div>
          @if (vm.maalerNr) {
            <small>Måler: {{ vm.maalerNr }}</small>
          }
          @if (vm.adresse && !vm.maalerNr) {
            <small>Status: Passiv</small>
          }
        </div>
        @if (vm.vaelgInstallationHref) {
          <small>SKIFT...</small>
        }
      </div>
    }
  </div>
}
